import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@mui/material';

const useStyles = makeStyles(theme => ({
  alternative: {
    marginTop: theme.spacing(1.75)
  },
  cancelButton: {
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(0.5, 1),
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    }
  },
  uppercaseText: {
    color: theme.palette.text.primary,
    textTransform: 'uppercase'
  }
}));

export const ResourceMatchCancelLink = ({ onClose }) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();

  return (
    <div data-qe-id="ResourceMatchCancelLink" className={classes.alternative}>
      <Button
        className={classes.cancelButton}
        onClick={onClose}
        variant="text"
        size="small"
      >
        <Typography variant="button" className={classes.uppercaseText}>
          {formatMessage({
            id: 'resourceMatchPopover.cancel'
          })}
        </Typography>
      </Button>
    </div>
  );
};

ResourceMatchCancelLink.propTypes = {
  onClose: PropTypes.func.isRequired
};

export default ResourceMatchCancelLink;
